import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Building2Icon } from 'lucide-react';
export function CommercialDumpsters() {
  return <div className="w-full min-h-screen bg-white" data-id="element-256">
      <Header data-id="element-257" />
      {/* Hero Section */}
      <section className="relative h-[400px] w-full" data-id="element-258">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4Tku44qLL3eVP7D6UtEer2/CommercialDumpsters.jpg" alt="Commercial Dumpsters" className="w-full h-full object-cover" data-id="element-259" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" data-id="element-260"></div>
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-261">
          <div className="text-center" data-id="element-262">
            <div className="w-20 h-20 bg-white rounded-lg flex items-center justify-center mx-auto mb-4" data-id="element-263">
              <Building2Icon className="w-10 h-10 text-[#E41C1C]" data-id="element-264" />
            </div>
            <h1 className="text-5xl font-bold text-white" data-id="element-265">
              Commercial Dumpsters
            </h1>
          </div>
        </div>
      </section>
      {/* Content Section */}
      <section className="py-16 bg-white" data-id="element-266">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
          <div className="space-y-6" data-id="element-268">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-269">
              Running a business comes with enough challenges—waste management
              shouldn't be one of them. Our commercial dumpster service provides
              reliable, scheduled pickups tailored to your business's specific
              needs. We offer containers in 2, 4, 6, and 8-yard sizes, ensuring
              you have the right capacity whether you're managing a small office
              or a busy restaurant generating significant daily waste.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-270">
              We understand that every business operates differently, which is
              why we work with you to establish a pickup schedule that fits your
              workflow. Our professional drivers arrive on time, handle the
              service efficiently, and keep your property looking clean and
              professional. From retail stores and medical offices to
              manufacturing facilities and restaurants, we've got the experience
              to handle your commercial waste needs.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-271">
              Partnering with a local company like Sam's Disposal means you get
              personalized attention and responsive customer service. If your
              needs change or you have special requests, we're just a phone call
              away. Our straightforward pricing and dependable service help you
              keep your business running smoothly while maintaining a clean,
              professional appearance for your customers and employees.
            </p>
          </div>
          {/* CTA Section */}
          <div className="mt-12 p-8 bg-gray-50 rounded-lg text-center" data-id="element-272">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-273">
              Get a Commercial Service Quote
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-274">
              Let us help you find the right dumpster size and pickup schedule
              for your business.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-275">
              <a href="tel:231-796-2952" className="bg-[#E41C1C] text-white font-bold px-8 py-4 rounded hover:bg-red-700 transition-colors text-lg" data-id="element-276">
                Call (231) 796-2952
              </a>
              <button className="bg-white border-2 border-[#E41C1C] text-[#E41C1C] font-bold px-8 py-4 rounded hover:bg-gray-50 transition-colors text-lg" data-id="element-277">
                Request Quote
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-278" />
    </div>;
}